<template>
  <div>
    <div class="text-center mt-8">
      <div class="loginBox mt-5 ">

        <v-window v-model="authWindow" touchless>
          <v-window-item value="signin">
            <div class="authForm" id="signin">
              <div class="text-center titleLogin mb-8">
                {{ $t('register') }}
              </div>
              <img src="../../assets/image/webp/login/avatar.webp" alt="">
              <v-form class="mt-5 mx-8 " ref="signInForm"
                      @keypress.native.enter="sendOtp">
                <v-text-field
                    v-model="signInForm.input"
                    outlined
                    :prepend-inner-icon="inputIcon"
                    :style="inputStyle"
                    :rules="inputRules"
                    ref="inputFieldRef"
                    :tab_index_number="1"
                    :label="inputLabel"
                    :type="inputType === 'phone' ? 'tel' : 'text'"
                    :placeholder="inputPlaceholder"
                    id="signinInput"
                ></v-text-field>

                <v-text-field
                    v-model="signInForm.password"
                    outlined
                    prepend-inner-icon="mdi-lock"
                    style="font-family: en-light !important;border-radius: 8px!important;"
                    :rules="passwordRules"
                    :type="signInForm.passwordType"
                    @click:append="changePassType"
                    append-icon="mdi-eye"
                    ref="passwordFieldRef"
                    :tab_index_number="2"
                    :label="$t('passwordLabel')"
                    id="password"
                ></v-text-field>

                <v-text-field
                    v-model="signInForm.confirmPassword"
                    outlined
                    prepend-inner-icon="mdi-lock"
                    style="font-family: en-light !important;border-radius: 8px!important;"
                    :rules="passwordConfirmRules"
                    :type="signInForm.confirmPasswordType"
                    @click:append="changeConfirmPassType"
                    append-icon="mdi-eye"
                    ref="confirmPasswordFieldRef"
                    :tab_index_number="3"
                    :label="$t('passwordConfirmationLabel')"
                    id="confirmPassword"
                ></v-text-field>

                <v-btn color="#46b1a1" class="white--text loginBtn mt-5" elevation="0"
                       @click="sendOtp"
                       :tab_index_number="2"
                       id="signInBtn"
                       :disabled="loadingStatus"
                       style="position: relative;z-index: 10">
                  {{ $t('onBoarding.continue') }}
                </v-btn>

                <p class="mt-2" style="color: grey;font-size: 15px" v-if="platFormInfoLS?.id != 4">
                  {{ $t('loginComponent.or') }}
                </p>
                <div class="loginMethod mt-2" v-if="platFormInfoLS?.id != 4">
                  <div class="loginItem" @click="loginBy('google')">
                    <div class="titleItem flex-grow-1 font-weight-bold">
                      {{ $t('loginComponent.googleSignIn') }}
                    </div>
                    <div class="iconItem  fill-height">
                      <img src="../../assets/matchMaking/google.svg" width="30px" alt="">
                    </div>
                  </div>
                </div>


                <v-btn :to="{name:'login'}" class="mt-5 mb-2" style="color: #6d6d6d;z-index: 9999"
                       text
                       id="loginBtn">
                  {{ $t('loginComponent.haveAccount') }}
                  <span style="color: #46b1a1" class="font-weight-bold">
                    {{ $t('loginComponent.login') }}
                  </span>
                </v-btn>
              </v-form>
            </div>
          </v-window-item>

          <v-window-item value="email-otp">
            <div class="authForm" id="email-otp">
              <div class="text-center titleLogin mb-8">
                {{ $t('loginComponent.enterVerificationCode') }}
              </div>
              <p class="mt-2 mb-4">
                {{ $t('loginComponent.verificationCodeSent') }}
                <b class="font-weight-bold">{{ signInForm.input }}</b>
              </p>
              <v-form @submit.prevent="submitEmailOtp">
                <div style="width: 70%;margin: 0px auto">
                  <v-otp-input
                      plain
                      type="number"
                      class="my-10"
                      @finish="submitEmailOtp"
                      style="direction: ltr;"
                      v-model="emailOtpCode"
                      length="6"
                  ></v-otp-input>
                </div>
                <v-btn color="#46b1a1" class="white--text loginBtn mt-5" elevation="0"
                       @click="submitEmailOtp"
                       :tab_index_number="3"
                       :disabled="loadingStatus"
                       style="position: relative;z-index: 10">
                  {{ $t('onBoarding.continue') }}
                </v-btn>
              </v-form>
              <v-btn
                  :disabled="otpTimer != 0"
                  text
                  class="mt-2"
                  style="z-index: 10"
                  color="#46b1a1"
                  @click="resendEmailOtp"
              >
                {{ $t('loginComponent.resendingCode') }}
              </v-btn>
              <br>
              {{ otpTimer / 60 | minFilter }}:{{ otpTimer % 60 | secFilter }}
            </div>
          </v-window-item>

          <v-window-item value="whatsapp-otp">
            <img src="../../assets/logo/Logo.svg" class="mt-2" alt="">
            <h3>
              {{ $t('loginComponent.enterVerificationCode') }}
            </h3>
            <p class="mt-2">
              {{ $t('loginComponent.verificationCodeSent') }}
              <b class="font-weight-bold">
                {{ $t('loginComponent.whatsapp') }}
              </b>
              {{ $t('loginComponent.sent') }}
            </p>
            <v-form @submit.prevent="submitWhatsappOtp">
              <div style="width: 70%;margin: 0px auto">
                <v-otp-input
                    plain
                    type="number"
                    class="my-10"
                    @finish="submitWhatsappOtp"
                    style="direction: ltr;border-color: red"
                    v-model="whatsappOtpCode"
                    length="6"
                ></v-otp-input>
              </div>
              <v-btn color="#46b1a1" class="white--text loginBtn mt-5" elevation="0"
                     @click="submitWhatsappOtp"
                     :tab_index_number="3"
                     :disabled="loadingStatus"
                     style="position: relative;z-index: 10">
                {{ $t('onBoarding.continue') }}
              </v-btn>
            </v-form>
            <v-btn
                :disabled="otpTimer != 0"
                text
                class="mt-2"
                style="z-index: 10"
                color="#46b1a1"
                @click="resendWhatsappOtp"
            >
              {{ $t('loginComponent.resendingCode') }}
            </v-btn>
            <br>
            {{ otpTimer / 60 | minFilter }}:{{ otpTimer % 60 | secFilter }}
          </v-window-item>

          <v-window-item value="register-otp">
            <div class="authForm" id="register-otp">
              <div class="text-center titleLogin mb-8">
                {{ $t('loginComponent.enterVerificationCode') }}
              </div>
              <p class="mt-2 mb-4">
                {{ $t('loginComponent.verificationCodeSent') }}
                <b class="font-weight-bold">{{ signInForm.input }}</b>
              </p>
              <v-form @submit.prevent="verifyOtp">
                <div style="width: 70%;margin: 0px auto">
                  <v-otp-input
                      plain
                      type="number"
                      class="my-10"
                      @finish="verifyOtp"
                      style="direction: ltr;"
                      v-model="registerOtpCode"
                      length="6"
                  ></v-otp-input>
                </div>
                <v-btn color="#46b1a1" class="white--text loginBtn mt-5" elevation="0"
                       @click="verifyOtp"
                       :tab_index_number="3"
                       :disabled="loadingStatus"
                       style="position: relative;z-index: 10">
                  {{ $t('onBoarding.continue') }}
                </v-btn>
              </v-form>
              <v-btn
                  :disabled="otpTimer != 0"
                  text
                  class="mt-2"
                  style="z-index: 10"
                  color="#46b1a1"
                  @click="resendRegisterOtp"
              >
                {{ $t('loginComponent.resendingCode') }}
              </v-btn>
              <br>
              {{ otpTimer / 60 | minFilter }}:{{ otpTimer % 60 | secFilter }}
            </div>
          </v-window-item>
        </v-window>
        <img src="../../assets/image/png/login/back.png" class="bottomBack" alt="">
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import {parsePhoneNumberFromString} from "libphonenumber-js";
import AuthMixins from "@/mixins/AuthMixins";
import EventsMixins from "@/mixins/EventsMixins";
import globalMixins from "@/mixins/globalMixins";

export default {
  mixins: [AuthMixins, EventsMixins, globalMixins],
  data() {
    return {
      authWindow: "signin",
      signInForm: {
        input: null,
        password: null,
        passwordType: 'password',
        confirmPassword: null,
        confirmPasswordType: 'password',
      },
      emailOtpCode: null,
      whatsappOtpCode: null,
      registerOtpCode: null,
      otpTimer: 300,
      timer: null,
      showEmailError: false,
      registeredUserData: null, // Store registration data for login after OTP verification
    }
  },
  computed: {
    // Detect if input is email or phone
    inputType() {
      if (!this.signInForm.input) return 'email'
      const input = this.signInForm.input.trim()
      // Check if it's an email (contains @ and valid email pattern)
      const emailPattern = /.+@.+\..{2}/
      if (emailPattern.test(input)) {
        return 'email'
      }
      // Check if it's a valid phone number
      let phone = input.replaceAll(' ', '')
      
      // Remove +98 if present
      if (phone.startsWith('+98')) {
        phone = '0' + phone.substring(3)
      }
      
      // Check if it starts with 09 and has correct length
      if (phone.startsWith('09') && phone.length === 11 && /^09\d{9}$/.test(phone)) {
        return 'phone'
      }
      
      // Also check with libphonenumber for international format
      const phoneNumber = parsePhoneNumberFromString(input)
      if (phoneNumber && phoneNumber.isValid()) {
        return 'phone'
      }
      
      // Default to email
      return 'email'
    },
    inputIcon() {
      return this.inputType === 'phone' ? 'mdi-cellphone' : 'mdi-email'
    },
    inputStyle() {
      const baseStyle = 'font-family: en-light !important;border-radius: 8px!important;'
      return this.inputType === 'phone' 
        ? baseStyle + 'direction: ltr;'
        : baseStyle
    },
    inputLabel() {
      return this.$t('emailLabel') + ' ' + this.$t('loginComponent.or') + ' ' + this.$t('signupComponent.phone')
    },
    inputPlaceholder() {
      return this.inputType === 'phone' 
        ? '09123456789'
        : this.$t('emailLabel')
    },
    inputRules() {
      // Validate that input is either valid email OR valid phone
      return [
        (v) => {
          if (!v) return this.$t('errors.fillIsRequired')
          const input = v.trim()
          
          // Check if it's a valid email
          const emailPattern = /.+@.+\..{2}/
          if (emailPattern.test(input)) {
            return true
          }
          
          // Check if it's a valid phone (starting with 09 or +98)
          let phone = input.replaceAll(' ', '')
          
          // Remove +98 if present
          if (phone.startsWith('+98')) {
            phone = '0' + phone.substring(3)
          }
          
          // Check if it starts with 09 and has correct length (11 digits: 09xxxxxxxxx)
          if (phone.startsWith('09') && phone.length === 11 && /^09\d{9}$/.test(phone)) {
            return true
          }
          
          // Also check with libphonenumber for international format
          const phoneNumber = parsePhoneNumberFromString(input)
          if (phoneNumber && phoneNumber.isValid()) {
            return true
          }
          
          // If neither email nor phone, return error
          return this.$t('errors.emailErrValid') + ' ' + this.$t('loginComponent.or') + ' ' + this.$t('Notify.signupComponent.phoneNumberError')
        }
      ]
    },
    detectedInputValue() {
      // Get the processed value (email or formatted phone)
      if (this.inputType === 'phone') {
        let phone = this.signInForm.input.replaceAll(' ', '')
        
        // Remove +98 if present and convert to 09 format
        if (phone.startsWith('+98')) {
          phone = '0' + phone.substring(3)
        }
        
        // If it's already in 09 format, return as is
        if (phone.startsWith('09') && phone.length === 11) {
          return phone
        }
        
        // Try to parse with libphonenumber
        const phoneNumber = parsePhoneNumberFromString(phone)
        if (phoneNumber && phoneNumber.isValid()) {
          // If parsed number starts with +98, convert to 09 format
          const parsedNumber = phoneNumber.number
          if (parsedNumber.startsWith('+98')) {
            return '0' + parsedNumber.substring(3)
          }
          return parsedNumber
        }
        
        return phone
      }
      return this.signInForm.input
    },
    passwordConfirmRules() {
      return [
        (v) => !!v || this.$t("Notify.signupComponent.rePasswordRequired"),
        (v) =>
          v === this.signInForm.password ||
          this.$t("Notify.signupComponent.rePasswordCheck"),
      ];
    }
  },
  filters: {
    secFilter(val) {
      let sec = Number(val).toFixed(0)
      if (sec < 10) {
        return '0' + sec
      }
      return sec
    },
    minFilter(val) {
      let min = Math.floor(val);
      if (min < 10) {
        return '0' + min
      }
      return min
    }
  },
  watch: {
    'signInForm.input'(newVal) {
      this.showEmailError = false
      
      // Auto-format phone numbers: remove +98 and ensure 09 format
      if (newVal && !newVal.includes('@')) {
        let phone = newVal.replaceAll(' ', '')
        
        // If starts with +98, remove it
        if (phone.startsWith('+98')) {
          phone = '0' + phone.substring(3)
          this.signInForm.input = phone
        }
      }
    }
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        if (this.otpTimer != 0) {
          this.otpTimer -= 1
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    resetTimer() {
      clearInterval(this.timer)
      this.otpTimer = 300
    },
    changePassType() {
      if (this.signInForm.passwordType == 'password') {
        this.signInForm.passwordType = 'text'
      } else {
        this.signInForm.passwordType = 'password'
      }
    },
    changeConfirmPassType() {
      if (this.signInForm.confirmPasswordType == 'password') {
        this.signInForm.confirmPasswordType = 'text'
      } else {
        this.signInForm.confirmPasswordType = 'password'
      }
    },
    loginBy(target) {
      switch (target) {
        case 'google':
          window.location.href = process.env.VUE_APP_BASE_URL + 'auth/social/google';
          break;
      }
    },
    sendOtp() {
      if (this.$refs.signInForm.validate()) {
        this.register()
      }
    },
    register() {
      // Determine if input is email or phone and prepare data accordingly
      const input = this.signInForm.input.trim()
      let registerData = {
        password: this.signInForm.password,
        password_confirmation: this.signInForm.confirmPassword,
      }
      
      // Check if it's email
      const emailPattern = /.+@.+\..{2}/
      if (emailPattern.test(input)) {
        registerData.email = input
      } else {
        // It's phone - validate and format
        let phone = input.replaceAll(' ', '')
        
        // Remove +98 if present and convert to 09 format
        if (phone.startsWith('+98')) {
          phone = '0' + phone.substring(3)
        }
        
        // Validate Iranian mobile format (09xxxxxxxxx)
        if (phone.startsWith('09') && phone.length === 11 && /^09\d{9}$/.test(phone)) {
          registerData.mobile = phone
        } else {
          // Try to parse with libphonenumber as fallback
          const phoneNumber = parsePhoneNumberFromString(input)
          if (phoneNumber && phoneNumber.isValid()) {
            let formattedPhone = phoneNumber.number
            // Convert +98 to 09 format
            if (formattedPhone.startsWith('+98')) {
              formattedPhone = '0' + formattedPhone.substring(3)
            }
            registerData.mobile = formattedPhone
          } else {
            this.$emitEvent('notify', {color: 'red', title: this.$t('Notify.signupComponent.phoneNumberError')})
            return
          }
        }
      }
      
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'register', '', registerData).then(() => {
        // Store registration data for login after OTP verification
        this.registeredUserData = registerData
        
        // Show OTP input window
        this.registerOtpCode = null
        this.authWindow = 'register-otp'
        this.startTimer()
        this.$emitEvent('setLoading', false)
      }).catch(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    verifyOtp() {
      if (!this.registerOtpCode) {
        this.$emitEvent('notify', {color: 'red', title: 'کد را وارد کنید'});
        return;
      }
      
      this.$emitEvent('setLoading', true)
      
      // Prepare verification data
      const verifyData = {
        otp: this.registerOtpCode
      }
      
      // Add email or mobile based on what was registered
      if (this.registeredUserData.email) {
        verifyData.email = this.registeredUserData.email
      } else if (this.registeredUserData.mobile) {
        verifyData.mobile = this.registeredUserData.mobile
      }
      
      this.requesting('auth', 'verifyOtp', '', verifyData).then((resp) => {
        // Token and profile are automatically set via commits in authRequests.js
        // No need to call login API - token is already in response
        
        this.$emitEvent('notify', {
          color: 'green',
          title: this.$t('Notify.signupComponent.success'),
          id: 'ga_signup'
        })
        
        const email = this.registeredUserData.email || ''
        const phone = this.registeredUserData.mobile || ''
        const userId = resp.data?.user?.id || this.$store.getters.getProfile?.id
        
        if (userId) {
          this.WebengageUserRegister(
            userId, 
            new Date(), 
            email, 
            phone
          )
          this.WebengageSetUserLoggedIn(userId)
        }
        
        this.$emitEvent('setLoading', false)
        this.$emit('afterSignIn')
      }).catch(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    resendRegisterOtp() {
      this.resetTimer()
      this.registerOtpCode = null
      // Resend OTP - backend should handle resending for existing unverified users
      // We'll call register again, backend should resend OTP if user exists
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'register', '', this.registeredUserData).then(() => {
        this.startTimer()
        this.$emitEvent('setLoading', false)
        this.$emitEvent('notify', {color: 'green', title: 'کد تأیید مجدداً ارسال شد'})
      }).catch(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    sendEmailOtp() {
      this.showEmailError = false
      this.emailOtpCode = null
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'sendEmailOtp', {}, {
        email: this.signInForm.input,
        action: 'register'
      }).then((resp) => {
        if (resp.data.error_code) {
          if (resp.data.error_code == 1001) {
            // Email already exists
            this.showEmailError = true
            this.$emitEvent('notify', {color: 'red', title: 'این ایمیل قبلاً ثبت شده است'});
          } else if (resp.data.error_code == 1003) {
            // OTP sent successfully
            this.authWindow = 'email-otp'
            this.startTimer()
          }
        } else {
          // OTP sent successfully
          this.authWindow = 'email-otp'
          this.startTimer()
        }
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    resendEmailOtp() {
      this.resetTimer()
      this.sendEmailOtp()
    },
    submitEmailOtp() {
      if (!this.emailOtpCode) {
        this.$emitEvent('notify', {color: 'red', title: 'کد را وارد کنید'});
        return;
      }
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'submitEmailOtp', {}, {
        email: this.detectedInputValue,
        action: 'register',
        otp: this.emailOtpCode,
        redirected_from: 'platroom',
      }).then(() => {
        this.$emitEvent('notify', {color: 'green', title: this.$t('Notify.signupComponent.success'), id: 'ga_signup'});
        setTimeout(() => {
          this.requesting('auth', 'getProfile').then(() => {
            this.WebengageSetUserLoggedIn(this.$store.getters.getProfile.id)
            this.$emit('afterSignIn')
          })
        }, 500)
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    sendWhatsappOtp() {
      let phone = this.signInForm.input.replaceAll(' ', '');
      const phoneNumber = parsePhoneNumberFromString(phone);
      if (phoneNumber && phoneNumber.isValid()) {
        this.$emitEvent('setLoading', true)
        // Try email OTP with phone number first (for registration)
        this.requesting('auth', 'sendEmailOtp', {}, {
          email: phoneNumber.number,
          action: 'register'
        }).then((resp) => {
          if (resp.data.error_code) {
            if (resp.data.error_code == 1001) {
              // Phone already exists
              this.$emitEvent('notify', {color: 'red', title: 'این شماره تماس قبلاً ثبت شده است'});
            } else if (resp.data.error_code == 1003) {
              // OTP sent successfully - use email OTP flow
              this.authWindow = 'email-otp'
              this.startTimer()
            }
          } else {
            // OTP sent successfully - use email OTP flow
            this.authWindow = 'email-otp'
            this.startTimer()
          }
        }).catch((err) => {
          // If email OTP doesn't work, try whatsapp OTP
          this.requesting('auth', 'send-whatsapp-otp', {}, {
            email: phoneNumber.number
          }).then((resp) => {
            this.authWindow = 'whatsapp-otp'
            this.startTimer()
          }).catch((err2) => {
            this.$emitEvent('notify', {color: 'red', title: 'لطفاً از ایمیل برای ثبت‌نام استفاده کنید'});
          }).finally(() => {
            this.$emitEvent('setLoading', false)
          })
        }).finally(() => {
          if (this.authWindow !== 'whatsapp-otp') {
            this.$emitEvent('setLoading', false)
          }
        })
      } else {
        this.$emitEvent('notify', {color: 'red', title: this.$t('Notify.signupComponent.phoneNumberError')});
      }
    },
    resendWhatsappOtp() {
      this.resetTimer()
      this.sendWhatsappOtp()
    },
    submitWhatsappOtp() {
      if (!this.whatsappOtpCode) {
        this.$emitEvent('notify', {color: 'red', title: 'لطفا کد را وارد کنید'});
        return;
      }
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'submit-whatsapp-otp', {}, {
        email: this.detectedInputValue,
        otp: this.whatsappOtpCode,
      }).then((resp) => {
        this.$emitEvent('notify', {color: 'green', title: 'خوش‌ آمدید', id: 'success_signup_whatsapp'});
        setTimeout(() => {
          this.requesting('auth', 'getProfile').then(() => {
            this.WebengageSetUserLoggedIn(this.$store.getters.getProfile.id)
            this.$emit('afterSignIn')
          })
        }, 1000)
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
  },
}
</script>

<style>
@media (min-width: 200px ) and (max-width: 600px) {
  .loginBox {
    width: 90% !important;
    margin: 10px auto !important;
  }
}

.loginBox {
  width: 414px;
  padding: 25px;
  margin: 0px auto;
  border-radius: 15px;
  box-shadow: 0 3px 17px 0 rgba(0, 0, 0, 0.07);
  border: solid 1px #fbfbfb;
  background-color: #fff;
  position: relative;
}

.bottomBack {
  position: absolute;
  bottom: 0px;
  width: 100%;
  right: 0px;
}

.loginBtn {
  width: 100%;
  height: 50px !important;
  font-size: 17px;
  font-weight: bolder;
  border-radius: 10px;
}

.titleLogin {
  font-size: 21px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: center;
  color: rgb(0, 0, 0);
}

.authForm {
  z-index: 999;
}

.loginMethod {
  margin-top: 0;
}

.loginItem {
  display: flex;
  cursor: pointer;
  border: 1px solid #ededed;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 0 3px 5px -3px rgba(0, 0, 0, .3);
  transition: all 0.3s;
}

.loginItem:hover {
  transition: all 0.3s;
  box-shadow: 0 5px 15px -7px rgba(0, 0, 0, .3);
}

.iconItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  padding: 5px;
}

.titleItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  padding: 5px;
  font-size: 12px;
  margin-right: 30px;
}
</style>

